import React from "react";
import PropTypes from "prop-types";

const Spinner = ({ text = "PATIDAR SAMAJ", isSpinner = false }) => {
  return (
    <>
      {isSpinner ? (
        <div className="loader-overlay">
          <div className="dancing-dots">
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
          </div>
        </div>
      ) : (
        <div className="hotel-air-container">
          <h1 className="hotel-air-text">
            {text.split("").map((ch, i) => (
              <span key={i} style={{ animationDelay: `${i * 0.1}s` }}>
                {ch}
              </span>
            ))}
          </h1>
        </div>
      )}
    </>
  );
};

Spinner.propTypes = {
  text: PropTypes.string,
  isSpinner: PropTypes.bool,
};

export default Spinner;
